import { Sequence } from 'remotion';

// Hooks
import { useSlideInAnimation } from '@/hooks';

// Constants
import { DECORATIVE_YEAR_ANIMATION } from '../constants';

// Themes
import { employeeYearInReviewTheme } from '@/components/EmployeeYearInReview/theme';

interface DecorativeYearProps {
  year: number;
  from?: number;
  durationInFrames?: number;
}

export const DecorativeYear = ({
  year,
  from = 0,
  durationInFrames,
}: DecorativeYearProps) => {
  const { colors, typography } = employeeYearInReviewTheme;
  // Slide-in animation for decorative year text (slides from top)
  const decorativeYearAnim = useSlideInAnimation({
    direction: DECORATIVE_YEAR_ANIMATION.DIRECTION,
    distance: DECORATIVE_YEAR_ANIMATION.DISTANCE,
    springConfig: DECORATIVE_YEAR_ANIMATION.SPRING_CONFIG,
    durationInFrames: DECORATIVE_YEAR_ANIMATION.DURATION_IN_FRAMES,
  });

  const yearString = year.toString();

  return (
    <Sequence
      name="Decorative Year"
      from={from}
      durationInFrames={durationInFrames}
    >
      {/* Background Decorative Year Numbers - Left Side */}
      <div
        className="absolute left-20 top-0 bottom-0 flex flex-col justify-center"
        style={{
          transform: decorativeYearAnim.transform,
        }}
      >
        <div
          className={`${typography.decorativeYear} ${colors.decorative} opacity-40 select-none [writing-mode:vertical-rl] [text-orientation:mixed] rotate-180 ml-[-40px]`}
        >
          {yearString}
        </div>
      </div>
    </Sequence>
  );
};
